import { useContext } from 'react';
import { TopNavContext } from '../providers/TopNavProvider';
import { useDidMount } from './useDidMount';

export const useTopNavVisibility = (type: 'top' | 'second' | 'third'): void => {
  const topNavOffsetContext = useContext(TopNavContext);

  useDidMount(() => {
    topNavOffsetContext.dispatch({
      type: 'updateVisibility',
      payload: { NavigationPositionType: type, NavigationVisibilityType: 'show' }
    });

    return () => {
      topNavOffsetContext.dispatch({
        type: 'updateVisibility',
        payload: { NavigationPositionType: type, NavigationVisibilityType: 'hide' }
      });
    };
  });
};
